module.exports = __webpack_public_path__ + "static/balancaN-693f3db88d65b5296393eec77583bf69.jpg";